/**
 * On Range Chipping Play Reducers
 */
import {
    ORTCHIPPING_ACTION,
    ALL_ORTCHIPPING,
    ADD_ORTCHIPPING,
    FETCH_ORTCHIPPING,
    EDIT_ORTCHIPPING,
    DELETE_ORTCHIPPING,
    FETCH_ORTCHIPPINGCHART,
    FETCH_ORTCHIPPINGSHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortchippinglist:[],
    particularortchipping:[],    
    ortchippingchart:[],
    ortchippingshotchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTCHIPPING_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTCHIPPING:
            return { ...state, loading: false, ortchippinglist: action.payload };     
            
        case ADD_ORTCHIPPING:
            return { ...state, loading: false };     
         
        case FETCH_ORTCHIPPING:
            return { ...state, loading: false, particularortchipping: action.payload };  
            
        case EDIT_ORTCHIPPING:
            return { ...state, loading: false }; 
            
        case DELETE_ORTCHIPPING:
            return { ...state, loading: false };     

        case FETCH_ORTCHIPPINGCHART:
            return { ...state, loading: false, ortchippingchart: action.payload };  

        case FETCH_ORTCHIPPINGSHOTCHART:
            return { ...state, loading: false, ortchippingshotchart: action.payload };  
        
        default: return { ...state };

     }
 }